import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { Slide, SlideImageContainer, SlideInformationText, SlideProps, SlideTitle } from "./Slide";
import { default as WomanSuccessVector } from "/public/assets/woman-success.svg?react";

export const Slide0MainSlide = ({ isBigScreen }: SlideProps) => {
  return (
    <MainSlide>
      <div>
        <SlideTitle>{translate(STRINGS.SLIDE_MAIN_TITLE_ALL_YOU_NEED_TO_KNOW)}</SlideTitle>
        <SlideInformationText>
          {translate(STRINGS.SLIDE_MAIN_INFO_GO_NEXT_SCREENS)}
        </SlideInformationText>
      </div>
      <SlideImageContainer>
        <WomanSuccessVector height={isBigScreen ? "80%" : "100%"} preserveAspectRatio={"none"} />
      </SlideImageContainer>
    </MainSlide>
  );
};

const MainSlide = styled(Slide)`
  justify-content: space-between;

  ${SlideInformationText} {
    margin-top: 8px;
    font-size: 16px;
  }
`;
